/**
 * Driver operation statuses arrive from the backend as English strings and are used as-is in logic
 * (icon selection, comparisons). The keys below are for display only - never compare against the translated text.
 */
const DRIVER_STATUS_LABEL_KEYS: Readonly<Record<string, string>> = {
  'In Yard': 'driverDashboard.status.inYard',
  'In Vehicle': 'driverDashboard.status.inVehicle',
  'En Route': 'driverDashboard.status.enRoute',
  'Stationary': 'driverDashboard.status.stationary',
  'Unknown': 'common.unknown'
};

/** Returns the translation key for a known backend status, or null so the caller can fall back to the raw value. */
export function getDriverStatusLabelKey(status: string | null | undefined): string | null {
  return status ? DRIVER_STATUS_LABEL_KEYS[status] ?? null : null;
}